(function () {
  'use strict'

  /**
   * @ngdoc directive
   * @name thismomentGlowModuleNavigation
   * @module thismoment.glow.component.module.navigation
   *
   * @description
   * The navigation module for glow
   *
   * @example <pre><code>&#x3C;thismoment-glow-navigation id=&#x22;1&#x22;&#x3E;&#x3C;/thismoment-glow-navigation&#x3E;</code></pre>
   */

  require('./scss/module-navigation.scss')

  var MODULE_NAME = 'thismoment.glow.component.module.navigation'
  var templateUrl = require('./tpl/module-navigation.html')

  angular
    .module(MODULE_NAME, [
      require('angular-ui-bootstrap/src/collapse')
    ])
    .component('thismomentGlowModuleNavigation', {
      templateUrl: templateUrl,
      bindings: {
        trackEvent: '&',
        moduleId: '<',
        name: '<',
        backgroundColor: '<',
        linksPosition: '<',
        margin: '<',
        navigationItems: '<',
        textLinkColor: '<',
        textLinkHoverColor: '<',
        activeBackgroundColor: '<',
        activeLinkColor: '<',
        path: '<'
      },
      controller: glowNavigationController
    })

  glowNavigationController.$inject = ['$scope', '$state', 'SdkConfig']
  function glowNavigationController ($scope, $state, SdkConfig) {
    var vm = this

    vm.styles = vm.classes = {}

    vm.$onInit = navigationInit

    function navigationInit () {
      vm.isNavCollapsed = true

      vm.styles = {
        wrapper: {
          'margin': vm.margin
        },
        navbar: {
          'background-color': vm.backgroundColor,
          'text-align': vm.linksPosition
        },
        item: {
          'text-align': vm.linksPosition
        },
        link: {
          'color': vm.textLinkColor
        },
        active: {
          'background-color': vm.activeBackgroundColor,
          'text-align': vm.linksPosition
        },
        activeLink: {
          'color': vm.activeLinkColor
        }
      }

      vm.hoverColor = hoverColor
      vm.trackNavClick = trackNavClick
      evaluateBreakpoint()
    }

    $scope.$on('breakpoint:resize', function (event) {
      evaluateBreakpoint()
      $scope.$apply()
    })

    function evaluateBreakpoint () {
      switch (SdkConfig.get('breakpoint')) {
        case 'xs':
          vm.isNavCollapsed = true
          break

        case 'sm':
        case 'md':
        case 'lg':
          vm.isNavCollapsed = false
          break
      }
    }

    function trackNavClick (route) {
      vm.trackEvent({
        action: 'Module Explored',
        properties: {
          'event trigger': 'clicked nav link',
          'event trigger detail': route
        }
      })
    }

    function hoverColor ($event) {
      var myLink = angular.element($event.target)
      var active = $event.target.getAttribute('data-path') === vm.path

      vm.hover = !vm.hover

      if (vm.hover) {
        myLink.css('color', vm.textLinkHoverColor)
      } else {
        var linkColor = active ? vm.activeLinkColor : vm.textLinkColor
        myLink.css('color', linkColor)
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-module/module-navigation/index.js